export function loggedInRedirect(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

export function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next({ name: 'Login' });
  }
}

export default {
  loggedInRedirect,
  isLoggedIn,
};



// WEBPACK FOOTER //
// ./src/router/guards.js